import { keywordsConstants } from '@constants/keywords';
import { DEFAULT_PAGE_SIZE } from '@constants/pagination';
import { keywordsService } from '@services';

export const keywordsActions = {
    get,
};

function get(data, page = 0, pageSize = DEFAULT_PAGE_SIZE) {
    return dispatch => {
        dispatch(request());
        return keywordsService.get(data, page, pageSize).then(
            data => dispatch(success(data)),
            () => dispatch(failure()),
        );
    };
}

function request() {
    return { type: keywordsConstants.KEYWORDS_REQUEST };
}

function success(data) {
    return { type: keywordsConstants.KEYWORDS_SUCCESS, data };
}

function failure() {
    return { type: keywordsConstants.KEYWORDS_ERROR };
}
